<div class="heading-1">
  <div
    class="heading-1__left"
    data-cy="heading-1.left">
    <ng-content select="[left]"></ng-content>
  </div>

  <div class="heading-1__right">
    <ng-content select="[right]"></ng-content>
  </div>
</div>
